import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=b9a3b3aa&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9a3b3aa')) {
      api.createRecord('b9a3b3aa', component.options)
    } else {
      api.reload('b9a3b3aa', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=b9a3b3aa&", function () {
      api.rerender('b9a3b3aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JPWUkWqt7wOt/JS/stardisplay.vue"
export default component.exports